

import { Highlight as TiptapHighlight } from '@tiptap/extension-highlight'
import { HighlightActionButton } from '@/tiptap/extensions/components/ActionButton'

export default TiptapHighlight.extend({
  addOptions() {
    return {
      ...(this.parent?.() || {}),
      multicolor: true,
      button: ({ editor, t }) => ({
        component: HighlightActionButton,
        componentProps: { editor, t },
      }),
    }
  },
})